import { faAngleRight, faMoneyBill1Wave } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useMemo, useRef, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import cn from 'classnames';
import { useClickOutside } from 'hooks/useClickOutside';
import { getEntityLink } from 'helpers/getEntityLink';
import { SUBSCRIPTION_TYPES_ICONS } from 'constants/subsctiptionTypes';
import { PaymentForm } from './PaymentForm';
import styles from '../PersonCell.scss';

export const PersonPlate = ({ bookingDate, person: p, role }) => {
  const [selectedPerson, setSelectedPerson] = useState(null);
  const navigate = useNavigate();
  const modalRef = useRef();

  const isSelected = useMemo(() => selectedPerson?.id === p.id, [selectedPerson, p.id]);
  const rolePath = role === 'client' ? 'clients' : 'coaches';
  const displayName = `${p.surname} ${p.name}`;
  const hasUnpaidBill = p.payment && !p.payment.paid;

  const handleCloseModal = useCallback(() => {
    setSelectedPerson(null);
  }, []);

  const handleToggleSelection = useCallback(() => {
    setSelectedPerson(isSelected ? null : p);
  }, [isSelected, p]);

  const handleNavigateToProfile = useCallback(() => {
    navigate(getEntityLink(`database/${rolePath}/${p.id}`));
  }, [navigate, rolePath, p.id]);

  useClickOutside(modalRef, handleCloseModal, isSelected);

  return (
    <span
      key={p.id}
      className={cn(styles.participant, {
        [styles.expanded]: isSelected,
      })}
      onClick={handleToggleSelection}
    >
      {p.payment && (
        <FontAwesomeIcon
          className={cn(styles.personIcon, styles.billStatus, {
            [styles.paid]: p.payment.paid,
            [styles.unpaid]: !p.payment.paid && new Date(p.payment.dueTime) < new Date(),
          })}
          icon={faMoneyBill1Wave}
        />
      )}
      {p.subscription && (
        <FontAwesomeIcon className={styles.personIcon} icon={SUBSCRIPTION_TYPES_ICONS[p.subscription.type]} />
      )}

      {displayName}

      {isSelected && (
        <div className={styles.modal} ref={modalRef}>
          <div className={cn(styles.profile, { [styles.billed]: hasUnpaidBill })} onClick={handleNavigateToProfile}>
            <div className={styles.avatar}>{`${p.surname?.[0] || ''}${p.name?.[0] || ''}`.toUpperCase()}</div>
            <div className={styles.fullNameField}>
              <div className={styles.column}>
                <span className={styles.fullName}>
                  {p.surname} {p.name}
                </span>
                <span className={styles.subtext}>Перейти на сторінку</span>
              </div>
              <FontAwesomeIcon className={styles.arrow} icon={faAngleRight} />
            </div>
          </div>

          {hasUnpaidBill && <PaymentForm bookingDate={bookingDate} payment={p.payment} balance={p.balance} onReset={handleCloseModal} />}
        </div>
      )}
    </span>
  );
};
